import { MapContainer, TileLayer, LayersControl } from "react-leaflet";
import L from "leaflet";
import { useApp } from "@/context/AppContext";

export function MapBase({ center = [0.4162, 9.4673], zoom = 6, children, className = "h-full w-full", testid = "map-container" }) {
  const { theme } = useApp();
  return (
    <div className={className} data-testid={testid}>
      <MapContainer center={center} zoom={zoom} className="h-full w-full" worldCopyJump>
        <LayersControl position="topright">
          <LayersControl.BaseLayer checked name={theme === "dark" ? "Canevas sombre (Esri)" : "Canevas clair (Esri)"}>
            <TileLayer key={theme} attribution="Esri, HERE, Garmin, &copy; OpenStreetMap contributors" maxNativeZoom={16}
              url={`https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/${theme === "dark" ? "World_Dark_Gray_Base" : "World_Light_Gray_Base"}/MapServer/tile/{z}/{y}/{x}`} />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="OpenStreetMap standard">
            <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="Satellite (Esri World Imagery)">
            <TileLayer attribution="Tiles &copy; Esri" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" />
          </LayersControl.BaseLayer>
        </LayersControl>
        {children}
      </MapContainer>
    </div>
  );
}

export const dotIcon = (color = "#D4AF37", size = 12) => L.divIcon({
  className: "plane-icon",
  html: `<div style="width:${size}px;height:${size}px;border-radius:50%;background:${color};border:2px solid #060911;box-shadow:0 0 8px ${color}"></div>`,
  iconSize: [size, size], iconAnchor: [size / 2, size / 2],
});

const FRESH = { recent: "#D4AF37", stale: "#64748B", no_signal: "#EF4444" };

export const planeIcon = (track = 0, freshness = "recent", selected = false, mlat = false) => {
  const c = selected ? "#10B981" : mlat && freshness === "recent" ? "#06B6D4" : FRESH[freshness] || "#64748B";
  const s = selected ? 30 : 22;
  return L.divIcon({
    className: "plane-icon",
    html: `<svg width="${s}" height="${s}" viewBox="0 0 24 24" style="transform:rotate(${track || 0}deg)"><path fill="${c}" stroke="#060911" stroke-width="0.8" d="M12 2c.6 0 1 .5 1 1.2V9l8 4.5v2l-8-2.3v4.6l2.3 1.7V21L12 20l-3.3 1v-1.5L11 17.8v-4.6L3 15.5v-2L11 9V3.2C11 2.5 11.4 2 12 2z"/></svg>`,
    iconSize: [s, s], iconAnchor: [s / 2, s / 2],
  });
};
